import React, { Component } from "react";
import { connect } from "react-redux";
import cx from "classnames";
import { CSSTransition } from "react-transition-group";
import PerfectScrollbar from "react-perfect-scrollbar";

import HeaderLogo from "components/Header/Logo";
import VerticalNavWrapper from "components/Menu/VerticalNavWrapper";
import { applyColor } from "utils/apply-color";
import { setEnableMobileMenu } from "reducers/ThemeOptions";

class Sidemenu extends Component {
  sidebarRef = React.createRef();

  render = () => {
    return (
      <>
        <div
          className="sidebar-mobile-overlay"
          onClick={() =>
            this.props.setEnableMobileMenu(!this.props.enableMobileMenu)
          }
        />
        <CSSTransition
          nodeRef={this.sidebarRef}
          in={true}
          appear={true}
          timeout={1500}
          classNames="SidebarAnimation"
          enter={false}
          exit={false}
        >
          <div
            ref={this.sidebarRef}
            className={cx("app-sidebar", {
              "sidebar-shadow": this.props.enableSidebarShadow,
            })}
            style={{
              backgroundColor: applyColor("$tertiary", this.props.colors),
            }}
          >
            <HeaderLogo />
            <PerfectScrollbar>
              <div className="app-sidebar__inner">
                <VerticalNavWrapper
                  userPermissions={this.props.userPermissions}
                  user={this.props.user}
                  userRole={this.props.userRole}
                />
              </div>
            </PerfectScrollbar>
          </div>
        </CSSTransition>
      </>
    );
  };
}

const mapStateToProps = (state) => ({
  enableBackgroundImage: state.ThemeOptions.enableBackgroundImage,
  enableSidebarShadow: state.ThemeOptions.enableSidebarShadow,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  colors: state.ClientReducer.clientInfo.styles?.colors,
  clientInfo: state.ClientReducer.clientInfo,
});

export default connect(mapStateToProps, { setEnableMobileMenu })(Sidemenu);
